import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import {clearActiveReport} from "../../../actions/reports";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";

const Submenu = ({ triggerContent, items, conditional }) => {
  const [isOpen, setIsOpen] = useState(false);
  const submenuRef = useRef(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setIsOpen(false);
      }
    };

    const handleClickOutside = (event) => {
      if (submenuRef.current && !submenuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      if (isOpen) {
        document.removeEventListener('keydown', handleKeyDown);
        document.removeEventListener('mousedown', handleClickOutside);
      }
    };
  }, [isOpen]);

  return (
    <div className="submenu-container" ref={submenuRef} role="group" aria-label="">
      <a
        href="/"
        className="submenu-trigger"
        onClick={(e) => {e.preventDefault(); setIsOpen(prev => !prev)}}
        aria-expanded={isOpen}
      >
        {triggerContent}
      </a>
      {isOpen && (
        <ul className="submenu-content">
          {items.map((item) => (conditional(item)) ? (
            <li key={item.path}>
              <a href={item.path} onClick={(e) => {
                e.preventDefault();
                dispatch(clearActiveReport());

                if (item.action) {
                  item.action();
                }

                setIsOpen(!isOpen);
                navigate(item.path);
              }}>
                {item.label}
              </a>
            </li>
          ) : '')}
        </ul>
      )}
    </div>
  );
};

Submenu.propTypes = {
  triggerContent: PropTypes.node.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default Submenu;